module.exports = __webpack_public_path__ + "img/Balkon_1.8acbba34.jpg";